import script from "./GlobusButtonPrimary.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusButtonPrimary.vue?vue&type=script&setup=true&lang=js"

import "./GlobusButtonPrimary.vue?vue&type=style&index=0&id=428cd04a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-428cd04a"]])

export default __exports__